import cn from 'classnames';
import { mapArticleTypeToTitle } from '@/finsight/ui/components/creditFlow/articles/constants';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import UpgradePlanButton from '@/finsight/ui/common/components/UpgragePlanButton';
import { ThemeType } from '@/finsight/domain/vo/CreditFlow/Articles/themeTypes';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import { iconStyles } from '@dealroadshow/uikit/core/components/Icon';
import IconInfo from '@dealroadshow/uikit/core/components/Icon/IconInfo';
import styles from './tileAccessFallback.scss';

const getTooltipContent = (type: ThemeType) => (
    `Real-time ${ type === ThemeType.commentary ? 'commentary' : 'deal updates' } on the credit market written by
    industry leading analysts with years of reporting experience.`
);

const TileAccessFallback = ({ articlesType }: { articlesType: ThemeType }) => {
  return (
    <div className={ styles.container }>
      <div className={ styles.titleContent }>
        <h3 className={ spacesStyles.mn }>{ mapArticleTypeToTitle[articlesType] }&nbsp;</h3>
        <Tooltip content={ getTooltipContent(articlesType) } containerClassName={ styles.questionIconTooltip }>
          <IconInfo
            className={ cn(iconStyles.smallIcon, styles.questionIcon) }
          />
        </Tooltip>
      </div>
      <UpgradePlanButton />
    </div>
  );
};

export default TileAccessFallback;
